import styled from "styled-components";
import {device} from "src/theme/theme";

export const Box = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 0.7rem;
  margin: 0.7rem 0;
  max-width: 400px;
  border-radius: 0.7rem;
  background: ${({ theme }) => theme.colors.palette.neutral200};
  transition: all 0.3s ease 0s;
  .card {
    display: flex;
  }

  .body-card {
    margin-left: 1rem;

    h3 {
      ${({ theme }) => theme.size.sm}
      margin: 0 0 0.2rem 0rem;

      @media ${device.mobileM} {
        margin: 0.5rem 0 0.2rem;
      };

    }
    span {
      ${({ theme }) => theme.size.xs}
    }
  }
`

export const Image = styled.div<{ image: string }>`
  width: 50px;
  height: 50px;
  border-radius: 50%;
  min-width: 50px;

  @media ${device.mobileM} {
    width: 80px;
    height: 80px;
    min-width: 80px;
  };
  div {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-image: url(${({ image }) => image});
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    border: 4px solid ${({ theme }) => theme.colors.secondaryBackgroundColor};
  }
`
